import type { Reducer } from 'redux';
import {
    WEEKLY_BREAKDOWN_REPORT_GET_START,
    WEEKLY_BREAKDOWN_REPORT_GET_SUCCESS,
    WEEKLY_BREAKDOWN_REPORT_GET_ERROR,
    WeeklyBreakdownReportAction
} from 'actions/insights/bookings/weeklyBreakdownReport/WeeklyBreakdownReportActionsTypes';

import {
    WeeklyBreakdownReportState,
    WeeklyBreakdownReportStatus,
    emptyWeeklyBreakdownReport
} from './WeeklyBreakdownReportState';

const initialState: WeeklyBreakdownReportState = {
    report: emptyWeeklyBreakdownReport,
    status: WeeklyBreakdownReportStatus.Initial,
    loading: false
};

export const WeeklyBreakdownReportReducer: Reducer<WeeklyBreakdownReportState, WeeklyBreakdownReportAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case WEEKLY_BREAKDOWN_REPORT_GET_START:
            return {
                ...state,
                status: WeeklyBreakdownReportStatus.Getting,
                loading: true
            };

        case WEEKLY_BREAKDOWN_REPORT_GET_SUCCESS:
            return {
                ...state,
                report: action.payload.report,
                status: WeeklyBreakdownReportStatus.GettingSuccess,
                loading: false
            };

        case WEEKLY_BREAKDOWN_REPORT_GET_ERROR:
            return {
                ...state,
                status: WeeklyBreakdownReportStatus.Error,
                loading: false
            };

        default:
            return state;
    }
};
